import styled from 'styled-components';
import { fontUi } from '../../../../theme/typography';

export const StyledLegend = styled.div`
  ${fontUi};
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  padding: 10px 0 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledLegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const StyledSwatch = styled.span`
  display: block;
  width: 4px;
  height: 14px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
`;
